import type { FunctionPlugin } from 'vue';

const AxeptioPlugin: FunctionPlugin = function () {
  window._axcb = window._axcb ?? [];

  // Wait for Axeptio to be ready
  // See https://developers.axeptio.eu/cookies/axeptio-javascript-sdk#using-a-callback-function-to-get-a-reference-to-the-sdk
  window._axcb.push(() => {
    if (window.hideAxeptioButton === undefined) {
      throw new Error('Callback "hideAxeptioButton" manquant.');
    }

    window.hideAxeptioButton();
  });
};

export default AxeptioPlugin;
